export function trackByUuid<T>(index: number, item: T & { uuid: string }): string {
  return item && item.uuid;
}
